import React, {useState, useEffect, useContext} from 'react';
import UpdatePhotoView from './UpdatePhotoView';
import api from '../../../../axios.config';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {deletePhoto, getFacture} from '../../../../services/MadricService';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';

/**
 * Permet l'ajout des médias
 * @return {JSX}
 */
function UpdatePhoto() {
  const [isLoading, setIsLoading] = useState(false);
  const {projectInfo, setProjectInfo, setWhatToShow} = useContext(MadricContext);
  const [factureName, setFactureName] = useState([]);


  const navigate = useNavigate();
  const location = useLocation();

  const [checked, setChecked] = useState(location.state.photo.type === 'facture');

  const [form, setForm] = useState({
    id: location.state.photo.id, 
    url: location.state.photo.url,
    montant: location.state.photo.montant,
    note: location.state.photo.note,
    factureNameForm: location.state.photo.facturenameUpdate,
    selectedDate: location.state.photo.date,
    extra1: location.state.photo.extra1,
    extra2: location.state.photo.extra2,
    extra3: location.state.photo.extra3,
    avancement: location.state.photo.avancement,
    type: location.state.photo.type,
  });

  useEffect(() => {
    fetchFactures();
  }, []);

  /**
   * Va chercher la liste des factures
   */
  async function fetchFactures() {
    await getFacture().then((res) => {
      setFactureName(res.map((item) => ({value: item.id, label: item.name})));
    });
  }

  const openModal = () => {
    const type = location.state.isFacture ? 'facture' : 'photo';
    swal('Votre ' + type + ' a été modifié');
  };

  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.checked,
    });
  };

  const handleFactureNameFormChange = (f) => {
    setForm({
      ...form,
      factureNameForm: f,
    });
  };

  /**
   * Permet de fermer le modal
   */
  function closeModal() {

    if(location.state.returnTo === 'global')
    {
      navigate('/InfoGlobal');
    }
    else if(location.state.returnTo === 'historique')
    {
      setWhatToShow('7');
      navigate('/chantier/' + location.state.id);
    }
    else
    {
      location.state.isFacture ? setWhatToShow('4') : setWhatToShow('3');
      navigate('/chantier/' + location.state.id);
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const nameFacture = form.factureNameForm === null || form.factureNameForm === 0 ? "null" : Array.isArray(form.factureNameForm) ? form.factureNameForm[0].label : form.factureNameForm.label;

    await api.put('/photos/' + location.state.photo.id, {
      montant: form.montant,
      note: form.note,
      date: form.selectedDate,
      extra1: form.extra1,
      extra2: form.extra2,
      extra3: form.extra3,
      avancement: form.avancement,
      factureName: nameFacture,
      isfacture: checked,
    }).then(() =>{
      openModal();
    }).finally(() => {
      setIsLoading(false);

      const updatedPhoto = projectInfo.map((p) => {
        if (p.id === form.id && (p.type === 'photo' || p.type === 'facture')) {
          return {
            ...p,
            montant: form.montant,
            note: form.note,
            date: form.selectedDate,
            extra1: form.extra1,
            extra2: form.extra2,
            extra3: form.extra3,
            avancement: form.avancement,
            factureNameUpdate: form.factureNameForm === null || form.factureNameForm === 0 ? null : form.factureNameForm,
            facturenameUpdate: form.factureNameForm === null || form.factureNameForm === 0 ? null : form.factureNameForm,
            facturename: form.factureNameForm === null || form.factureNameForm === 0 ? null : form.factureNameForm.label,
            factureName: form.factureNameForm === null || form.factureNameForm === 0 ? null : form.factureNameForm.label,
            type: checked ? 'facture' : 'photo',
          };
        }
        return p;
      });

      updatedPhoto.sort((a, b) => {
        const dateCompare = b.date.localeCompare(a.date);
        if (dateCompare !== 0) {
          return dateCompare;
        }

        return b.user_id - a.user_id;
      });
      setProjectInfo(updatedPhoto);

      if(location.state.returnTo === 'global')
      {
        navigate('/InfoGlobal');
      }
      else if(location.state.returnTo === 'historique')
      {
        setWhatToShow('7');
        navigate('/chantier/' + location.state.id);
      }
      else
      {
        location.state.isFacture ? setWhatToShow('4') : setWhatToShow('3');
        navigate('/chantier/' + location.state.id);
      }

    });
  };

  /**
   * Permet de supprimer la photo
   */
  function handleDelete() {
    const type = location.state.isFacture ? 'facture' : 'photo';
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer cette ' + type,
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            setIsLoading(true);
            const filtered = projectInfo.map((obj) => {
              return obj.id === form.id && (obj.type === 'photo' || obj.type === 'facture')? null : obj;
            }).filter((item) => item !== null);

            setProjectInfo(filtered);

            await deletePhoto(location.state.photo.id, location.state.id);
            setIsLoading(false);

            swal('Supprimé!', {
              icon: 'success',
            });

            if(location.state.returnTo === 'global')
            {
              navigate('/InfoGlobal');
            }
            else if(location.state.returnTo === 'historique')
            {
              setWhatToShow('7');
              navigate('/chantier/' + location.state.id);
            }
            else
            {
              location.state.isFacture ? setWhatToShow('4') : setWhatToShow('3');
              navigate('/chantier/' + location.state.id);
            }
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <UpdatePhotoView
        handleSubmit={handleSubmit}
        factureName={factureName}
        handleFactureNameFormChange={handleFactureNameFormChange}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        closeModal={closeModal}
        handleDelete={handleDelete}
        form={form}
        setForm={setForm}
        type={location.state.isFacture}
        setChecked={setChecked}
        checked={checked}
      />
    </React.Fragment>
  );
}

export default UpdatePhoto;
